import {destroyCookie, parseCookies, setCookie} from "utils/nookies";
import {
    CookiesConstants,
    DEVICE_UUID_COOKIE_AGE_IN_DAYS,
    LocalStorageConstants,
    LogoutCookies,
} from "utils/constants";
import {jsonSafeGet} from "utils/Helpers";
import useLocalStorage from "../../hooks/useLocalStorage";
import {IMember} from "../../screens/AccountMembership/_private/types/midView";

export const FIELDS_USER_INFO = [
    "id",
    "full_name",
    "profile_picture",
    "phone_number",
    "hasPassword",
    "membership_type"
];
const AUTH_LOCAL_STORAGE_KEY = "auth_v1";

export type LiteUserInfo = {
    id: number;
    full_name: string;
    profile_picture: string;
    phone_number: string;
    membership_type:string;

};

export type AuthTicketType = {
    t: number;
    k: string;
    deviceUUID?: string
};

export type AuthV2Type = {
    t: number;
    k: string;
    deviceUUID:string
};
export type AuthType = {
    isUserLoggedOut?: boolean;
    authToken?: string;
    source?: "desktop" | "mobile";
    authTokenExpires?: number;
    tgtTimestamp?: number;
    tgtTicket?: string;
    deviceUUID?: string;
    userInfo?: LiteUserInfo;
    sessionId?: string;
    sessionStartedAt?: number;
    defaultCurrency?:string;
};
export const getLocalStorageAuthUser = (): AuthType => {
    const cookies = parseCookies();
    const {getItem} = useLocalStorage();
    const source =
        cookies[CookiesConstants.SOURCE] ??
        (screen.width > 800 ? "desktop" : "mobile");
    const defaultAuthObject = {
        authToken: getItem<string>(LocalStorageConstants.AUTH_TOKEN),
        authTokenExpires: getItem<number>(LocalStorageConstants.AUTH_TOKEN_EXPIRES),
    };
    const userInfo= jsonSafeGet<LiteUserInfo>(cookies[CookiesConstants.USER_INFO]);
    const isLoggedOut = !userInfo?.id;
    const fromCookieAuthObject = {
        userInfo,
        tgtTimestamp: jsonSafeGet<AuthTicketType>(
            cookies[CookiesConstants.AUTH],
            {}
        ).t|| cookies[CookiesConstants.TGT_TIMESTAMP],
        tgtTicket: jsonSafeGet<AuthTicketType>(cookies[CookiesConstants.AUTH], {})
            .k|| cookies[CookiesConstants.TGT_TICKET],
        deviceUUID:
            cookies[CookiesConstants.DEVICE_UUID] ||
           ( isLoggedOut ? cookies[CookiesConstants.TRACKING_ID] : null ),
        source,
        sessionId: jsonSafeGet<any>(cookies[CookiesConstants.SESSION], {})?.id,
        sessionStartedAt: Number(jsonSafeGet<any>(cookies[CookiesConstants.SESSION], {})?.startedAt),

    };

    let localStorageAuthObject: AuthType;
    try {
        localStorageAuthObject = JSON.parse(
            localStorage.getItem(AUTH_LOCAL_STORAGE_KEY) || "{}"
        );
    } catch (e) {
    }
    //prioritise:
    //1. Cookies data
    //2. localStorage data
    //3. then default empty authToken & empty authTokenExpires

    return {
        ...defaultAuthObject,
        ...localStorageAuthObject,
        ...fromCookieAuthObject,
    };
};

export const setLocalStorageAuthUser = (data: AuthType) => {
    const {setItem} = useLocalStorage();
    const defaultAuth = getLocalStorageAuthUser();
    const authData: AuthType = {
        ...defaultAuth,
        ...data,
    };


    setCookie(
        null,
        CookiesConstants.USER_INFO,
        JSON.stringify(authData.userInfo)
    );
    if (authData.userInfo?.id) {
        setCookie(
            //@todo move to JSON helper to get/set data safelynull,
            null,
            CookiesConstants.AUTH,
            JSON.stringify({t: authData.tgtTimestamp, k: authData.tgtTicket})
        );
    }

  if (authData.tgtTimestamp) {
        destroyCookie(null, CookiesConstants.TGT_TIMESTAMP);
    }
    if (authData.tgtTicket) {
        destroyCookie(null, CookiesConstants.TGT_TICKET);
    }
    setItem(LocalStorageConstants.AUTH_TOKEN, authData.authToken|| "");
    setItem(
        LocalStorageConstants.AUTH_TOKEN_EXPIRES,
        new Date(data.authTokenExpires).getTime()
    );
};

export const minimizeUserInfoFields = (
    userInfo: IMember
): LiteUserInfo | null => {
    if (!userInfo?.id) return null;
    const filtered_m = {};

    FIELDS_USER_INFO.forEach((f) => {
        filtered_m[f] = userInfo[f];
    });
    return filtered_m as LiteUserInfo;
};

export const destroyLocalStorageAuthUser = () => {
    const {setItem} = useLocalStorage();
    setItem(LocalStorageConstants.AUTH_TOKEN, "");
    LogoutCookies.forEach((key) => {
        destroyCookie(null, key);
    });
    document.dispatchEvent(
        new CustomEvent("on-logout-success", {
            detail: {},
        })
    );
    //localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
};
export const emptyUserInfo = () => {
    destroyCookie(null, CookiesConstants.USER_INFO);
};
